import '.aw{position:relative;}.ssr-plugin'
import '.j8{width:64px;}.ssr-plugin'
import '.j9{height:64px;}.ssr-plugin'
import '.aq{flex-shrink:0;}.ssr-plugin'
import '.c8{position:absolute;}.ssr-plugin'
import '.ja{bottom:-4px;}.ssr-plugin'
import '.i7{right:-4px;}.ssr-plugin'
import '.ga{border-radius:50%;}.ssr-plugin'
import '.jb{border:2px solid var(--palette-white);}.ssr-plugin'
import '.al{overflow:hidden;}.ssr-plugin'
import '.jc{width:32px;}.ssr-plugin'
import '.jd{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="aw j8 j9 aq"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="c8 ja i7 ga jb al jc jd"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
